/**
 * Update user's privacy settings
 */
export const updatePrivacySettings = async (apiCall, settingKey, value) => {
  try {
    const response = await apiCall('/api/settings/privacy', {
      method: 'PUT',
      body: JSON.stringify({
        [settingKey]: value
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    if (!data.success) {
      throw new Error(data.message || 'Failed to update privacy settings');
    }

    return {
      success: true,
      data: data.data,
      privacySettings: data.data.privacySettings
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Failed to update privacy settings. Please try again.'
    };
  }
};

/**
 * Get login activity (devices and sessions)
 */
export const getLoginActivity = async (apiCall) => {
  try {
    const response = await apiCall('/api/settings/login-activity');
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    if (!data.success) {
      throw new Error(data.message || 'Failed to get login activity');
    }

    return {
      success: true,
      devices: data.data.devices,
      currentSession: data.data.currentSession
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Failed to get login activity. Please try again.'
    };
  }
};